<ul class="breadcrumb d-none d-sm-block">
  <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs">
    <a [routerLink]="[breadcrumb.url]">{{ breadcrumb.label }}</a>
  </li>
</ul>
